

import { Component, Vue } from 'vue-property-decorator'
import { DatetimeUtils, localeData } from '@/_utils/datetime'
import { Filter } from '@/_utils/filter'
import { Constant } from '@/_services/constant'
import DateRange from '@/_interfaces/DateRange'
import moment from 'moment-timezone'

@Component({
  components: {},
  computed: {},
})
export default class DateRangeMixin extends Vue {
  // data
  filterUtilDateRange: any = new Filter('filter_socan_analytic_daterange')
  queryDateFormat = 'YYYY-MM-DD'
  dateRange: DateRange = {
    startDate: DatetimeUtils.getTime(DatetimeUtils.last7Days()),
    endDate: DatetimeUtils.getTime(DatetimeUtils.nowEnd()),
  }
  localeData: any = localeData()

  datetimeUtils: any = DatetimeUtils

  get dateFrom(): number {
    return DatetimeUtils.getTime(this.dateRange.startDate)
  }

  get dateTo(): number {
    return DatetimeUtils.getTime(this.dateRange.endDate)
  }

  get dateRangeFormated(): any {
    return (picker) =>
      [
        this.datetimeFormatter(picker.startDate),
        this.datetimeFormatter(picker.endDate),
      ].join(' - ')
  }

  datetimeFormatter(value) {
    return moment(value).format(Constant.DATE_FORMAT)
  }

  saveDaterange() {
    this.filterUtilDateRange.save(this.dateRange)
  }
}
